// Shopify option value is misspelt as "One Siz"; normalise for display
function fixOneSize(value) {
  return typeof value === 'string' && /^one[\s\u00a0\u200b-\u200d\ufeff-]*siz$/i.test(value.trim()) ? 'One Size' : value
}

// let oldPushState = history.pushState;
// history.pushState = function pushState() {
//   let ret = oldPushState.apply(this, arguments);
//   console.log('push', arguments)
//   if (arguments[1] !== 'anchor-product' && arguments[0]?.hasOwnProperty('refinementList')) {
//   }
//   return ret;
// };

if (!customElements.get('mobile-bag')) {
  customElements.define('mobile-bag', class MobileBag extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()
        const variants = JSON.parse(this.getAttribute('data-variants')).sort((a, b) => Number(a.text) - Number(b.text))
        window.mobileTrackingHit = JSON.parse((this.getAttribute('data-hit')))
        document.querySelector('.mobile-quick-add').classList.remove('no-select')
        document.querySelector('.mobile-quick-add .q-value').innerHTML =
          variants.map(item => `<div class="q-item size-var ${item.text.toLowerCase()} ${item.available ? '' : 'oss'} ${variants.length === 1 ? 'active' : ''}" data-id="${item.id}">${item.text.toUpperCase()}</div>`).join('')

        if (variants.length === 1) {
          document.querySelector('.mobile-quick-add .q-value').style.display = 'none'
          window.mobileQuickAddTargetVariant = Number(variants[0].id)
          document.querySelector('mobile-quick-add .q-text').classList.remove('disabled')
          document.querySelector('mobile-quick-add header div').style.display = 'none'
        } else {
          document.querySelector('.mobile-quick-add .q-value').style.display = 'flex'
          document.querySelector('mobile-quick-add header div').style.display = 'block'
        }
        setTimeout(() => document.querySelectorAll('mobile-quick-add .q-item').forEach(item => item.addEventListener('click', (event) => {
          document.querySelectorAll('mobile-quick-add .q-item').forEach(sub => sub.classList.remove('active'))

          event.target.classList.add('active')
          window.mobileQuickAddTargetVariant = Number(event.target.getAttribute('data-id'))
          document.querySelector('mobile-quick-add .q-text').classList.remove('disabled')
          document.querySelector('.mobile-quick-add').classList.remove('no-select')
        })), 50)
        document.querySelector('.ais-mobile-quick-add').classList.add('visible')
      })
    }
  })
}

if (!customElements.get('pdp-redirect')) {
  customElements.define('pdp-redirect', class PDPRedirect extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', () => {
        const url = new URL(location);
        url.searchParams.set("page", this.getAttribute('data-page'));
        history.pushState({}, "anchor-product", url);
        location.href = this.getAttribute('data-url')
        sessionStorage.setItem('plp-object-id', this.getAttribute('data-object-id'))
      })
    }
  })
}

window.renderVariantIndex = 0

/**
 * Product grid loading mode for this page.
 *
 * assets/algolia_instant_search.js resolves the theme setting (and restricts it to
 * collection pages) and publishes the result on algoliaShopify.plpMode. It runs as
 * a deferred module, so it has always executed by the time DOMContentLoaded fires
 * here. The fallback keeps this file working if that script is absent or bailed out
 * early, in which case there is no grid to page anyway.
 */
function getPlpMode() {
  if (window.algoliaShopify && window.algoliaShopify.plpMode) {
    return window.algoliaShopify.plpMode
  }

  return 'infinite'
}

function triggerLoadMore() {
  if (document.querySelector('.ais-InfiniteHits-loadMore')
    ?.classList.contains('ais-InfiniteHits-loadMore--disabled')) {
    return
  }

  if (document.querySelector('.ais-InfiniteHits-loadMore')) {
    window.renderVariantIndex = 0
    document.querySelector('.ais-page').classList.add('ais-loading')
    document.querySelector('.ais-InfiniteHits-loadMore')?.click()
  } else {
    setTimeout(() => {
      triggerLoadMore()
    }, 100)
  }
}

// let isFirstLoadMore = true
document.addEventListener('DOMContentLoaded', () => {
  if (location.pathname.includes('collections') || location.pathname.includes('search')) {
    const plpMode = getPlpMode()

    let watchFooter

    let footer = document.querySelector('#shopify-section-footer')

    /**
     * Infinite scroll: press the (hidden) Load More button on the customer's behalf
     * as the footer comes into view. In load_more mode the button is visible and the
     * customer presses it themselves; in numbered mode there is no button at all.
     * Either way the observer must not run.
     */
    if (plpMode === 'infinite') {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!document.querySelectorAll('.ais-InfiniteHits-item').length) {
            return
          }
          if (entry.isIntersecting) {
            triggerLoadMore()
          }
        });
      }, {
        threshold: 0,
        // rootMargin: watchFooter
        //   ? '0px 0px 0px 0px'
        //   : `${footer.clientHeight * 2}px 0px 0px 0px`
      });

      observer.observe(footer)
    }

    /**
     * In infinite mode triggerLoadMore() resets the variant render counter and puts
     * the grid into its loading state before clicking. When the customer drives the
     * grid themselves — a Load More press or a page-number click — nothing does that,
     * so do it here. The loading class is cleared again by the product template
     * (snippets/algolia_instant_search_product.liquid) once cards start rendering.
     */
    if (plpMode === 'load_more' || plpMode === 'numbered') {
      const paginationTrigger = plpMode === 'numbered'
        ? '.ais-Pagination-link'
        : '.ais-InfiniteHits-loadMore, .ais-InfiniteHits-loadPrevious'

      document.addEventListener('click', (event) => {
        if (!event.target?.closest?.(paginationTrigger)) {
          return
        }

        window.renderVariantIndex = 0
        document.querySelector('.ais-page')?.classList.add('ais-loading')
      })
    }

    let loadPreScrollAnchor = null
    let needScrollForPrevious = false
    let hasSetUpLoadPrevious = false

    const listObs = new MutationObserver((mutations) => {
      // console.log(mutations)
      if (!hasSetUpLoadPrevious) {
        document.querySelector('.ais-InfiniteHits-loadPrevious')?.addEventListener('click', () => {
          loadPreScrollAnchor = document.querySelector('.ais-InfiniteHits-list li:nth-child(1)')
          needScrollForPrevious = true
        })
        hasSetUpLoadPrevious = true
      } else if (needScrollForPrevious && mutations.find(item => item.target.classList.contains('ais-InfiniteHits-list'))) {
        setTimeout(() => {
          loadPreScrollAnchor.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 200)
        needScrollForPrevious = false
      }
    })

    listObs.observe(document.querySelector('.ais-hits-container'), {
      childList: true,
      subtree: true
    })
  }


  function setAutoCompleteTop() {
    const panel = document.querySelector('.aa-Panel')
    if (panel && window.innerWidth > 680) {
      const rect = document.querySelector('#header .main-search .search-wrap .form').getBoundingClientRect()
      panel.style.top = `${rect.bottom + window.scrollY}px`
    }
  }

  window.addEventListener('scroll', () => {
    setAutoCompleteTop()
  })

  document.querySelector('#header').addEventListener('transitionend', () => {
    setAutoCompleteTop()
  })
  document.querySelector('.nav-search').addEventListener('click', (e) => {
    // if (window.innerHeight <= 680) {
    //   $('.aa-DetachedSearchButton').click()
    //   console.log('search click')
    // } else {
    const child = e.target.matches(".nav-search, .nav-search *");
    if (child) {

      $('body').addClass('se-st');
      setTimeout(function () {
        $('body').addClass('se');

        // Off the collection and search templates the Algolia bundle is fetched on first
        // search intent, so wait for it before touching anything it renders.
        const chain = window.algoliaSearchChain
        const ready = chain && chain.load ? chain.load() : Promise.resolve()

        ready.then(() => {
          if (window.innerWidth <= 680) {
            // Algolia mounts its own detached button once it runs. Excluding .nav-search
            // stops this matching the header trigger itself, which would click it and
            // recurse on templates where the bundle has not loaded yet.
            const detached = document.querySelector('.aa-DetachedSearchButton:not(.nav-search)')

            if (!detached) {
              return
            }

            detached.click()
            document.body.style.overflow = 'hidden'

            setTimeout(() => {
              document.querySelector('.aa-DetachedCancelButton')?.addEventListener('click', () => {
                document.body.style.overflow = ''
                document.querySelector('.main-search .close')?.click()
              })
            }, 50);
          } else {
            $('#autocomplete-0-input').focus()
          }
        }).catch(() => {})
      }, 50);
    }

    // }
  })

})

if (!customElements.get('swipe-handle')) {
  customElements.define('swipe-handle', class SwipeHandle extends HTMLElement {
    constructor(props) {
      super(props);

      this.addEventListener('click', event => {
        event.stopPropagation()
        event.stopImmediatePropagation()
        event.preventDefault()

        if (this.classList.contains('pre-btn')) {
          window[`fy_${this.getAttribute('data-object-id')}`].previous()
        } else {
          window[`fy_${this.getAttribute('data-object-id')}`].next()
        }
      })
    }

  })
}
window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.top_desktop .close').addEventListener('click', () => {
    document.body.removeChild(
      document.querySelector('.aa-Panel:last-child')
    )
  })
  if (!mobileCheck()) {
    history.scrollRestoration = 'manual';
  }

  document.querySelector('.cart-btn button')?.addEventListener('click', () => {
    try {
      const localStorageKey_pdp = 'localStorageKey_pdp';
      algoliaShopify.saveForConversionTracking(JSON.parse(localStorage.getItem(localStorageKey_pdp)));
    } catch (e) {
      console.error(e)
    }
  })


})

// Shared by both the initial PLP card render (algolia_instant_search_product.liquid) and
// the colour-swatch re-render below: video autoplays by default. The desktop hover-swap
// to the secondary image is handled entirely by the existing .desktop-hover-image CSS
// fade (same as every other card), so this only needs to pause the video behind it on
// hover and resume it on unhover, plus pause/resume as the card leaves/re-enters the
// viewport so off-screen videos aren't left running.
window.algoliaSetupVideoCard = function algoliaSetupVideoCard(card) {
  const video = card.querySelector('.videoc video')
  if (!video) return

  // A colour swap rebuilds the carousel for the same card element - tear down the
  // previous listeners first so they don't stack.
  if (typeof card._videoCardCleanup === 'function') {
    card._videoCardCleanup()
  }

  const isDesktop = () => window.matchMedia('(min-width: 769px)').matches
  let hovering = false
  let inView = true

  const play = () => video.play().catch(() => {})

  const onEnter = () => {
    if (!isDesktop()) return
    hovering = true
    video.pause()
  }

  const onLeave = () => {
    // Clear the flag before the width check, not after: if the viewport crosses below
    // 769px while the pointer is still over the card, an early return here would strand
    // `hovering` at true and the IntersectionObserver below would never resume the video
    // again for the life of the card.
    hovering = false
    if (!isDesktop()) return
    if (inView) play()
  }

  const hoverTarget = card.querySelector('.inside')
  hoverTarget.addEventListener('mouseenter', onEnter)
  hoverTarget.addEventListener('mouseleave', onLeave)

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      inView = entry.isIntersecting
      if (hovering) return
      if (inView) {
        play()
      } else {
        video.pause()
      }
    })
  }, {threshold: 0.1})

  observer.observe(video)

  card._videoCardCleanup = () => {
    hoverTarget.removeEventListener('mouseenter', onEnter)
    hoverTarget.removeEventListener('mouseleave', onLeave)
    observer.disconnect()
  }
}

if (!customElements.get('algolia-product')) {
  customElements.define('algolia-product', class AlgoliaProduct extends HTMLElement {
    constructor() {
      super();
      this.colorGroupData = null;
      this.isLoading = false;
    }

    connectedCallback() {
      // 读取 data-color-group 属性
      const targetElement = this.querySelector("#color-swatch");

      if (targetElement) {
        this.loadColorGroupProducts(targetElement);
      }
    }

    async loadColorGroupProducts(targetElement) {
      // 防止重复请求
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      try {
        fetch(`/products/${this.getAttribute('data-handle')}?section_id=plp-product-metafields`)
          .then(res => res.text())
          .then(res => {
            const html = new DOMParser().parseFromString(res, 'text/html')
            const script = html.querySelector('script[type="application/json"]')
            const data = JSON.parse(script.textContent)

            if (data.product_group) {
              const url = `/collections/available-products?filter.p.m.product.product_code_erp=${data.product_group}`;
              fetch(url)
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.text();
                })
                .then((html) => {
                  if (targetElement) {
                    const currentSwatchId = this.getAttribute("data-swatch-id")
                    const tempDiv = document.createElement('div')
                    tempDiv.innerHTML = html
                    const allDivs = Array.from(tempDiv.querySelectorAll('div'))

                    const sortedDivs = allDivs.sort((a, b) => {
                      const aMatches = a.getAttribute('data-swatch-id') === currentSwatchId
                      const bMatches = b.getAttribute('data-swatch-id') === currentSwatchId
                      if (aMatches && !bMatches) return -1
                      if (!aMatches && bMatches) return 1
                      return 0
                    }).filter(item => item.style.display !== 'none')

                    targetElement.innerHTML = sortedDivs.map(div => div.outerHTML).join('')

                    targetElement.querySelectorAll('div').forEach(item => {
                      if (item.getAttribute('data-swatch-id') === currentSwatchId) {
                        item.classList.add('active')
                      }
                    })

                    if (sortedDivs.length > 2) {
                      const plusElement = document.createElement('div')
                      plusElement.innerHTML = '+' + (sortedDivs.length - 2)
                      plusElement.classList.add('plus')
                      targetElement.appendChild(plusElement)
                    }
                  } else {
                    console.error("Target element or content not found.");
                  }
                })
                .catch((error) => {
                  console.error("Error fetching or injecting content:", error);
                });
            }
          })
      } finally {
        this.isLoading = false;
      }
    }

    // 获取颜色组数据的公共方法
    getColorGroupData() {
      return this.colorGroupData;
    }

    // 刷新颜色组数据
    async refreshColorGroupData() {
      const colorGroup = this.getAttribute('data-color-group');
      if (colorGroup && colorGroup !== 'null' && colorGroup !== 'undefined') {
        this.colorGroupData = null;
        this.isLoading = false;
        await this.loadColorGroupProducts(colorGroup);
      }
    }
  })
}

if (!customElements.get('plp-color-swatch')) {
  customElements.define('plp-color-swatch', class PLPColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.classList?.contains('plus')) {
          return
        }

        let handle = ''
        if (event.target.getAttribute('data-swatch-id')) {
          handle = event.target
        } else {
          handle = event.target.parentElement
        }

        event.stopPropagation()
        event.stopImmediatePropagation()
        event.preventDefault()
        this.querySelectorAll('[data-swatch-id]').forEach(item => {
          item.classList.remove('active')
        })

        handle.classList.add('active')

        handle.closest('pdp-redirect').setAttribute('data-url', handle.querySelector('a').getAttribute('href'))
        handle.closest('algolia-product').querySelector('.media-container').setAttribute('href', handle.querySelector('a').getAttribute('href'))
        handle.closest('algolia-product').querySelector('.main-carousel').setAttribute('data-url', handle.querySelector('a').getAttribute('href'))

        const script = handle.querySelector('script[type="application/json"]')
        const data = JSON.parse(script.textContent)

        const card = this.closest('algolia-product')

        // 构建 product-item-label HTML
        function buildProductLabels(tags, namedTags, price, compareAtPrice) {
          let productLabels = []
          let isSet = false

          // 检查是否是 SET 产品
          if (namedTags && namedTags['CODE']) {
            if (Array.isArray(namedTags['CODE'])) {
              isSet = !!namedTags['CODE'].find(item => item.includes("I'M A SET"))
            } else if (typeof namedTags['CODE'] === 'string') {
              isSet = namedTags['CODE'].includes("I'M A SET")
            }
          }

          // Dedupe badges by their logical name (case-insensitive) rather than by
          // substring-matching rendered HTML. Mirrors the snippet renderer
          // (algolia_instant_search_product.liquid) so PLP cards and swatch rebuilds
          // produce identical labels, and a badge whose href contains another badge's
          // name (e.g. FINAL -> /collections/final-sale) can't suppress the Sale badge.
          const seenLabels = new Set()
          const isOnSale = !!(compareAtPrice && price && compareAtPrice > price)

          // FINAL and SALE render as a single "Final Sale" badge when both apply, so the card
          // never reads "Final | Sale". Claiming the 'sale' key here stops the Sale badge added
          // further down from appending a second time. Either badge on its own is unaffected.
          function addLabel(name, label) {
            const key = String(name == null ? '' : name).trim().toLowerCase()
            let text = label == null ? name : label
            if (!key || seenLabels.has(key)) return
            seenLabels.add(key)
            if (key === 'final' && isOnSale) {
              seenLabels.add('sale')
              text = 'Final Sale'
            }
            const badge = window.theme?.materialBadge?.find(b => b.name && b.name.toLowerCase() === key)
            productLabels.push(
              badge?.link
                ? `<span><a href="${badge.link}">${text}</a></span>`
                : `<span>${text}</span>`
            )
          }

          // 处理 Badges
          const tagPrefix = (window.algoliaShopify && window.algoliaShopify.config && window.algoliaShopify.config.product_tag_prefix) || 'CODE:';
          if (tags && (tags.find(item => item.includes('Badges|')) || tags.find(item => item.includes(tagPrefix)))) {
            const badgesArray = tags
              .filter(item => item.includes('Badges|') || item.includes(tagPrefix))
              .map(item => item.replace('Badges|', '').replace(tagPrefix, ''))

            let badgeName
            if (badgesArray.includes('100% FRENCH LINEN')) {
              badgeName = '100% FRENCH LINEN'
            } else if (badgesArray.includes('SELLING FAST')) {
              badgeName = 'SELLING FAST'
            } else if (badgesArray.includes('RECYCLED')) {
              badgeName = 'RECYCLED MATERIAL'
            } else {
              for (const tag of badgesArray) {
                if (tag) {
                  badgeName = tag
                  break
                }
              }
            }

            if (badgeName) {
              addLabel(badgeName, badgeName.toLowerCase())
            }
          }

          // 处理 named_tags 中的 CODE 标签
          if (namedTags) {
            Object.keys(namedTags).forEach(item => {
              const value = namedTags[item]
              if (!item.includes('CODE')) return

              const name = Array.isArray(value) ? value[value.length - 1] : value
              if (name) {
                addLabel(name, String(name).toLowerCase())
              }
            })
          }

          // 处理 new 标签
          if (tags) {
            for (const key of tags) {
              if (key.includes('new')) {
                addLabel('new', 'New')
                break
              }
            }

            // 处理 coming-soon 标签
            if (tags.find(item => item.includes('coming-soon'))) {
              addLabel('coming soon', 'Coming Soon')
            }
          }

          // 处理 Sale 标签
          if (compareAtPrice && price && compareAtPrice > price) {
            addLabel('sale', 'Sale')
          }

          return productLabels.join('')
        }

        // 获取 algolia-product 的 data-show-swipe 和 data-video-tag 属性
        // data-video-tag holds the tag name itself (or '') rather than a boolean string.
        const showSwipe = card.getAttribute('data-show-swipe') === 'true'
        const videoTag = !!card.getAttribute('data-video-tag')

        // 同步 renderProductImage 中的逻辑
        function isVideoLink(url) {
          const videoRegex = /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)/i;
          return videoRegex.test(url);
        }

        // 先排序，把视频排到前面，再限制最多3张
        const allImages = data.productImages || []
        const sortedImages = allImages.sort((a, b) => {
          const aIsVideo = a.type === 'video' || isVideoLink(a.src)
          const bIsVideo = b.type === 'video' || isVideoLink(b.src)

          // 视频排在前面
          if (aIsVideo && !bIsVideo) return -1
          if (!aIsVideo && bIsVideo) return 1
          return 0 // 保持原有顺序
        })

        const hitImage = sortedImages.slice(0, 3) // 限制最多3张
        // 修改为处理对象结构，检查 type 或 src 来判断是否为视频
        const firstVideo = hitImage.find(item =>
          item.type === 'video' || isVideoLink(item.src)
        )

        // 构建移动端图片 HTML，同步 renderProductImage 的逻辑
        let mobileImageHtml = ''

        // 如果有视频且 videoTag 为 true，添加视频元素
        if (firstVideo && videoTag) {
          mobileImageHtml += `
              <div class="carousel-cell videoc"><video
                    src="${firstVideo.src}" autoplay muted loop preload="auto" playsinline
                    height=""
                    style=""
              ></video></div>
           `
        }

        // 添加非视频图片
        if (hitImage.length > 1) {
          hitImage.filter(item =>
            item.type !== 'video' && !isVideoLink(item.src)
          ).forEach((item, i) => {
            mobileImageHtml += `
                  <img alt="image"
                        class="fade-in-from-left swap--visible secondary carousel-cell"
                        style="visibility: hidden;"
                        data-sizes="auto"
                        data-flickity-lazyload="${item.src}&width=500"
                        height=""
                        style=""
                  />
               `
          })
        }

        // 更新桌面端 hover 图片（使用第二张图片） - rendered for video-tagged cards too,
        // since the fade-swap works the same way regardless of the video.
        if (hitImage.length > 1) {
          const secondImage = hitImage.filter(item =>
            item.type !== 'video' && !isVideoLink(item.src)
          )[1]
          const hoverImageEl = card.querySelector('.desktop-hover-image')
          if (secondImage && hoverImageEl) {
            hoverImageEl.src = secondImage.src
          }
        }

        // 更新现有轮播图片元素
        card.querySelectorAll('.carousel-cell').forEach((item, index) => {
          if (hitImage[index] && hitImage[index].src) {
            item.src = hitImage[index].src
          } else {
            item.style.display = 'none'
          }
        })

        // 更新移动端轮播图片
        const mobileSwipeContainer = card.querySelector('.mobile-swipe-images')
        if (mobileSwipeContainer) {
          // 销毁现有的 Flickity 实例
          const objectID = card.getAttribute('data-algolia-objectid')
          const existingFlkty = window[`fy_${objectID}`]
          if (existingFlkty) {
            existingFlkty.destroy()
          }

          // 更新 HTML 内容
          mobileSwipeContainer.innerHTML = mobileImageHtml

          // 重新初始化 Flickity
          setTimeout(() => {
            const flktyConfig = {
              cellAlign: 'left',
              prevNextButtons: false,
              wrapAround: true,
              lazyLoad: 1,
              pageDots: true,
              dragThreshold: 10,
              // On desktop, cards showing a video rely on the .desktop-hover-image fade
              // for the hover swap, not on a carousel drag - since that overlay is
              // pointer-events:none, an undisabled drag lets the mouse reach the carousel
              // underneath and slide it to an image cell, permanently replacing the video
              // instead of just pausing it behind a fade. Mobile has no hover state, so it
              // keeps swiping between the video and images as normal.
              // Keyed off what this rebuild actually rendered rather than off the card's
              // product-level video tag: a swatch can select a colour with no video of its
              // own, and that colour's image-only carousel should still drag on desktop.
              draggable: !mobileImageHtml.includes('<video') || !window.matchMedia('(min-width: 769px)').matches,
              on: {
                ready() {
                  card.querySelectorAll('.placeholder')
                    .forEach(item => {
                      item.src = "{{ 'Loading_Image_Grey_nologo.jpg' | asset_url }}";
                      item.setAttribute('alt', 'Loading Image')
                    })
                }
              }
            };

            const flkty = new Flickity(mobileSwipeContainer, flktyConfig);

            // 如果包含视频，等待视频加载元数据
            if (mobileImageHtml.includes('<video')) {
              setTimeout(() => {
                flkty.reposition()
              }, 50)
            }

            window[`fy_${objectID}`] = flkty

            if (mobileImageHtml.includes('<video') && typeof window.algoliaSetupVideoCard === 'function') {
              window.algoliaSetupVideoCard(card)
            }

            flkty.on('lazyLoad', (event, cellElement) => {
              cellElement.style.visibility = 'visible'
            })

            // 重新添加点击事件处理器
            flkty.on('staticClick', (clickEvent) => {
              clickEvent.preventDefault()
              clickEvent.stopPropagation()

              const targetHit = card
              const url = new URL(location);
              url.searchParams.set("page", mobileSwipeContainer.getAttribute('data-page'));
              url.searchParams.set("scrollTo", mobileSwipeContainer.getAttribute('data-url'));
              history.pushState({}, "anchor-product", url);
              location.href = mobileSwipeContainer.getAttribute('data-url')
            })

            card.querySelector('.inside .media-container').classList.remove('disabled')
          }, 100)

          // 如果图片数量少于等于1，隐藏滑动控制
          if (hitImage.length <= 1) {
            card.querySelectorAll('swipe-handle').forEach(item => {
              item.style.display = 'none'
            })
          }
        }

        // 处理 variant 数据并更新 quick-add HTML
        if (data.variants && data.variants.length > 0) {
          let firstAvailableVariant = data.variants.find(v => v.available)
          const quickAddContainer = card.querySelector('.quick-add .qvalue')
          if (quickAddContainer) {
            // 创建新的 variant HTML
            let variantHtml = ''

            data.variants.forEach(variant => {
              const size = fixOneSize(variant.option2)?.toLowerCase() || ''
              const isActive = firstAvailableVariant?.id === variant.id && data.variants.length === 1
              const isOOS = !variant.available

              variantHtml += `<div class="${isOOS ? 'oos' : ''} size-var ${size} ${isActive ? 'active' : ''}" data-p-id="${variant.id}">${size}</div>`
            })

            // 更新 quick-add 区域
            quickAddContainer.innerHTML = variantHtml

            // 不需要额外添加点击事件，因为 theme.js 已经通过事件委托处理了
            // 事件委托在 theme.js 第 2188 行：$('body').on('click','.qvalue [data-p-id]',function(){...})
          }
          // Update the price. Sizes priced differently show the price range, with
          // the RRP range struck only when every size is marked down, matching
          // snippets/card-price.liquid and algolia.helpers.cardPrice; otherwise
          // the first available variant's price.
          const priceContainer = card.querySelector('.price')
          if (priceContainer && firstAvailableVariant) {
            // Shop money format, so swatch-swapped cards match server-rendered ones (e.g. $1,000.00)
            const rate = Number(window.Shopify.currency.rate)
            const formatCents = cents => slate.Currency.formatMoney(Math.round(cents * rate), theme.moneyFormat)
            const formatRange = values => `${formatCents(Math.min(...values))} - ${formatCents(Math.max(...values))}`
            const prices = data.variants.map(variant => variant.price)
            const isRange = Math.min(...prices) !== Math.max(...prices)

            let priceHtml
            if (isRange) {
              const allMarkedDown = data.variants.every(variant => variant.compareAtPrice > variant.price)
              priceHtml = allMarkedDown
                ? `<span class="money compare nocur">${formatRange(data.variants.map(variant => variant.compareAtPrice))}</span><span class="money sale">${formatRange(prices)}</span>`
                : `<span class="money">${formatRange(prices)}</span>`
            } else {
              const price = firstAvailableVariant.price
              const comparePrice = firstAvailableVariant.compareAtPrice
              priceHtml = comparePrice && comparePrice > price
                ? `<span class="money compare nocur">${formatCents(comparePrice)}</span><span class="money sale">${formatCents(price)}</span>`
                : `<span class="money">${formatCents(price)}</span>`
            }

            priceContainer.innerHTML = priceHtml
          }

          // 更新 mobile-add-button 的 data-variants 属性
          const mobileAddBtn = card.querySelector('.mobile-add-button')
          if (mobileAddBtn) {
            const mobileVariants = data.variants.map(variant => ({
              id: variant.id,
              available: variant.available,
              text: fixOneSize(variant.option2)?.toLowerCase() || ''
            }))
            mobileAddBtn.setAttribute('data-variants', JSON.stringify(mobileVariants))
          }
        }

        // 更新 product-item-label
        const labelContainer = card.querySelector('.product-item-label')
        if (labelContainer && Array.isArray(data.tags)) {
          const firstAvailableVariant = data.variants?.find(v => v.available)
          const labelsHtml = buildProductLabels(
            data.tags,
            data.namedTags,
            firstAvailableVariant?.price,
            firstAvailableVariant?.compareAtPrice
          )
          labelContainer.innerHTML = labelsHtml
        }

        this.setAttribute('data-current-swatch-id', event.target.getAttribute('data-swatch-id'))
      })
    }
  })
}